import { MailOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button, Tooltip, Typography } from 'antd';
import React from 'react';

interface EmailColumnProps {
  email?: string | any;
  className?: string;
  width?: number;
}

export default React.memo((props: EmailColumnProps) => {
  const { email, className, width } = props;
  return (
    <StyledContainer className={className || ''}>
      <Button type="primary" shape="circle" icon={<MailOutlined />} />
      <Tooltip placement="top" title={email || false}>
        <Typography.Text style={{ width: width || 200 }}>{email || 'TBD'}</Typography.Text>
      </Tooltip>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  button {
    background: transparent;
    border-color: black;
    color: black;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  .ant-typography {
    min-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;
